<template>
    <div>
        <el-table
                :data="orderTryingCarts"
                size="medium"
                :height="400"
                style="width: 100%">
            <el-table-column
                    prop="semester_name"
                    label="学期"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="课程名称"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="teacher_name"
                    label="老师"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="time"
                    label="时间"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="class_period"
                    label="已上课次"
                    width="80">
                <template slot-scope="scope">
                    {{ scope.row.finished_period }}/{{ scope.row.class_period }}
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleRestoreCart(scope.row.id)"
                               :loading="$parentInfo.dialog_TryingCart.button_loading">恢复
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "Dialog_TryingCart",
        data() {
            return {

            }
        },
        computed: {
            orderTryingCarts: function () {
                return this._.values(this.$parentInfo.dialog_TryingCart.tryingCarts);
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleStudentTryingCarts();
        },
        methods: {
            handleStudentTryingCarts(){
                this.$wApi.send(this.$parentInfo.path, 'get_student_trying_cart', {
                    'student_id':this.$parentInfo.student_id,
                })
            },
            handleRestoreCart(cart_id) {
                this.$wApi.send(this.$parentInfo.path, 'restore_student_trying_cart', {
                    'student_id':this.$parentInfo.student_id,
                    'cart_id':cart_id,
                })
            },
        }
    }
</script>

<style scoped>

</style>